import React from 'react';
import { documentDefinition, attributeDefinition } from '../../types/Search';

export interface Props {
    data: documentDefinition;
    large?: boolean;
}
export const TooltipContent: React.FC<Props> = (props) => {
    if (props.data === undefined) {
        return <></>;
    }

    let cleanedAttributes: attributeDefinition[] = [];

    const uniqueAttributeNames = props.data?.attributes
        .map((att) => att.name)
        .filter((value, index, self) => self.indexOf(value) === index);
    cleanedAttributes = uniqueAttributeNames.map((name) => {
        const matchingAttributes = props.data?.attributes.filter((att) => att.name == name);
        const newAttribute = { ...matchingAttributes[0] };
        const uniqueValues: string[] = [];
        matchingAttributes.forEach((att) =>
            uniqueValues.push(...att.value.split(',').map((x) => x.trim()))
        );
        newAttribute.value = uniqueValues
            .filter((value, index, self) => self.indexOf(value) === index)
            .join(', ');
        return newAttribute;
    });

    // props.data?.attributes.forEach((attribute) => {
    //     let existingAttribute = cleanedAttributes.filter(function (e) {
    //         return e.name === attribute.name;
    //     })[0];
    //     if (existingAttribute) {
    //         if (!existingAttribute.value.includes(attribute.value)) {
    //             existingAttribute.value += ', ' + attribute.value;
    //         }
    //     } else {
    //         let newAttribute: attributeDefinition = {
    //             name: attribute.name,
    //             description: attribute.description,
    //             displayOrder: attribute.displayOrder,
    //             value: attribute.value,
    //             abbreviation: 'N/A',
    //             isDescriptor: false,
    //         };
    //         cleanedAttributes.push(newAttribute);
    //     }
    // });

    const filteredAndSortedAttributes = cleanedAttributes
        .filter((a) => a.displayOrder != '-1')
        .sort((a1, a2) => (a1.displayOrder < a2.displayOrder ? -1 : 1));

    const nameStyle = {
        fontSize: `${props.large ? '12pt' : '10pt'}`,
    };

    const valueStyle = {
        paddingLeft: '5px',
        fontSize: `${props.large ? '12pt' : '10pt'}`,
    };

    return (
        <>
            <table className='image-info-popup'>
                <tbody>
                    <tr>
                        <td>
                            <span style={nameStyle}>State:</span>
                            <span style={valueStyle}>{props.data?.state}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span style={nameStyle}>County:</span>
                            <span style={valueStyle}>{props.data?.county}</span>
                        </td>
                    </tr>
                    {props.data?.imageType !== 'HIERARCHY' && (
                        <>
                            <tr>
                                <td>
                                    <span style={nameStyle}>Type:</span>
                                    <span style={valueStyle}>{props.data?.imageType}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span style={nameStyle}>SubType:</span>
                                    <span style={valueStyle}>{props.data?.imageSubType}</span>
                                </td>
                            </tr>
                        </>
                    )}
                    {filteredAndSortedAttributes.map((attribute, i) => {
                        return (
                            <tr key={i}>
                                <td>
                                    <span style={nameStyle}>
                                        {attribute.description.replaceAll('_', ' ')}:
                                    </span>
                                    <span style={valueStyle}>{attribute.value}</span>
                                </td>
                            </tr>
                        );
                    })}
                    {props.data?.byteCount !== 0 && (
                        <tr>
                            <td>
                                <span style={nameStyle}>File Size:</span>
                                <span style={valueStyle}>{props.data?.byteCount}</span>
                            </td>
                        </tr>
                    )}
                    {props.data?.pageCount !== 0 && (
                        <tr>
                            <td>
                                <span style={nameStyle}>No. of page(s):</span>
                                <span style={valueStyle}>{props.data?.pageCount}</span>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
};

export default TooltipContent;
